import { compose } from 'recompose';

import InputView from './InputView';

export default compose()(InputView);
